// Shared copy-to-clipboard helper + a mixin for the transient "Copied" state
// that several lists render (SavedNotesList, insight cards, the insight
// dialog). `copiedKey` holds the key of the item copied in the last ~1.5 s.

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text == null ? "" : String(text));
    return true;
  } catch (err) {
    console.error("Clipboard write failed:", err);
    return false;
  }
}

// Plain text plus an HTML flavour (for Docs/Slides pastes). Falls back to
// plain text where ClipboardItem is unavailable or the write is refused.
export async function copyContent({ text, html }) {
  const plain = text == null ? "" : String(text);
  try {
    if (
      html &&
      typeof window !== "undefined" &&
      window.ClipboardItem &&
      navigator.clipboard &&
      navigator.clipboard.write
    ) {
      const item = new window.ClipboardItem({
        "text/plain": new Blob([plain], { type: "text/plain" }),
        "text/html": new Blob([html], { type: "text/html" }),
      });
      await navigator.clipboard.write([item]);
      return true;
    }
  } catch (err) {
    /* fall back to plain text below */
  }
  return copyText(plain);
}

export const copyFeedbackMixin = {
  data() {
    return { copiedKey: null };
  },
  beforeUnmount() {
    clearTimeout(this._copyFeedbackTimer);
  },
  methods: {
    // `payload` is a string or { text, html }.
    async copyWithFeedback(key, payload, ms = 1500) {
      const ok =
        payload && typeof payload === "object"
          ? await copyContent(payload)
          : await copyText(payload);
      if (!ok) return false;
      this.copiedKey = key;
      clearTimeout(this._copyFeedbackTimer);
      this._copyFeedbackTimer = setTimeout(() => {
        if (this.copiedKey === key) this.copiedKey = null;
      }, ms);
      return true;
    },
  },
};
